import axios from "axios";

export const createApiFetchFunction = (apiUrl) => {
	return async (offset = 0, limit = 20, searchTerm = "") => {
		return axios.get(apiUrl, {
			params: { offset, limit, search: searchTerm },
		});
	};
};
